import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useAppDispatch } from '~/reducers/useAppDispatch';
import { updateSearchFilters } from '~/cards/actions/cardCatalogActions';
import { getDisplayableSearchTotal } from '~/cards/selectors/cardCatalogSelector';
import {
  CARD_TYPE_MAP,
  PAPER_ADD_ONS_LEAD_CARD_TYPES,
} from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import { PAPER_ADD_ON_FILTER_TYPES_MAP } from '~/cards/constants/paperAddOnsFilterTypes';
import { PAPER_ADD_ONS_FILTERS, PaperAddOnsFilterType } from './constants';

import { FilterChip } from '../CardListingFilter/FilterStyles.styles';
import { PaperAddOnsFiltersWrapper, PaperAddOnsFilterPillsWrapper } from './styles';

export const PaperAddOnsFilters: React.FC = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { fullUrlQuery } = router.query;

  const [activeFilterType, setActiveFilterType] = useState<string | null>(null);

  const productCount = useSelector(getDisplayableSearchTotal);

  useEffect(() => {
    const { card_type = '' } = (fullUrlQuery as unknown) as {
      card_type: string | string[] | undefined;
    };
    const urlCardType = Array.isArray(card_type) ? card_type[0] : card_type;

    setActiveFilterType(
      PAPER_ADD_ON_FILTER_TYPES_MAP.get(urlCardType) || CARD_TYPE_MAP.paperAddOns
    );
  }, [fullUrlQuery]);

  const handleClick = (filterData: PaperAddOnsFilterType) => {
    window.history.pushState({}, '', `/wedding-planning/paper-add-ons/shop${filterData.search}`);

    const isPaperAddOns = filterData.type === CARD_TYPE_MAP.paperAddOns;

    dispatch(
      updateSearchFilters('lead_card_types', isPaperAddOns ? PAPER_ADD_ONS_LEAD_CARD_TYPES : null)
    );
    dispatch(updateSearchFilters('lead_card_type', filterData.type));

    return setActiveFilterType(filterData.type);
  };

  return (
    <PaperAddOnsFiltersWrapper>
      <PaperAddOnsFilterPillsWrapper data-testid="plp-filters-wrapper">
        {PAPER_ADD_ONS_FILTERS.map((filter) => (
          <FilterChip onClick={() => handleClick(filter)} active={filter.type === activeFilterType}>
            {filter.name}
          </FilterChip>
        ))}
      </PaperAddOnsFilterPillsWrapper>
      <div data-testid="plp-search-total">
        {productCount === 1 ? '1 result' : `${productCount} results`}
      </div>
    </PaperAddOnsFiltersWrapper>
  );
};
